import { FilterListRounded } from '@mui/icons-material';
import { Stack, Typography, OutlinedInput } from '@mui/material';
import { UserInfo } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

interface CustomFilterModalNameInputProps {
  filterName: string | undefined;
  setFilterName: (filterName: string) => void;
  actionType?: 'EDIT' | 'SAVE';
  createdBy?: UserInfo;
}

export const CustomFilterModalNameInput = ({
  filterName,
  setFilterName,
  actionType = 'SAVE',
  createdBy,
}: CustomFilterModalNameInputProps) => {
  const { id: userID } = useGetUser();

  const createdByText =
    createdBy?.id === userID
      ? 'You'
      : `${createdBy?.firstName} ${createdBy?.lastName}`;

  return (
    <Stack spacing={1} mb={2}>
      <Stack justifyContent="space-between" direction="row">
        <Stack spacing={0.5} alignItems="center" direction="row">
          <FilterListRounded
            sx={{
              fontSize: 'inherit',
              color: 'text.secondary',
            }}
          />
          <Typography variant="body2" color="text.secondary">
            Custom Filter name
          </Typography>
        </Stack>

        {actionType === 'EDIT' && createdBy && (
          <Typography variant="body2" color="text.secondary">
            Created by: {createdByText}
          </Typography>
        )}
      </Stack>
      <OutlinedInput
        id="custom-filter-name-id"
        placeholder="Enter a name..."
        size="small"
        required
        fullWidth
        value={filterName}
        onChange={(event) => {
          setFilterName(event.target.value);
        }}
      />
    </Stack>
  );
};
